import { render, staticRenderFns } from "./Sponsors.vue?vue&type=template&id=d853f728&scoped=true&"
var script = {}
import style0 from "./Sponsors.vue?vue&type=style&index=0&id=d853f728&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d853f728",
  null
  
)

export default component.exports